import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#services", label: "Serviços", testid: "nav-services-link" },
  { href: "#plans", label: "Planos", testid: "nav-plans-link" },
  { href: "#portfolio", label: "Portefólio", testid: "nav-portfolio-link" },
  { href: "#gallery", label: "Estúdio", testid: "nav-gallery-link" },
  { href: "#faq", label: "FAQ", testid: "nav-faq-link" },
  { href: "#contact", label: "Contacto", testid: "nav-contact-link" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-ink/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-5 md:px-10 lg:px-16 py-4">
        <a href="#home" data-testid="nav-home-link" className="flex items-center gap-3 group">
          <img src="/logo.png" alt="MATRAKA" className="h-24 md:h-28 w-auto group-hover:rotate-[-3deg] transition-transform" />
        </a>

        <nav className="hidden lg:flex items-center gap-1 bg-white/5 border border-white/10 rounded-full px-2 py-1.5 backdrop-blur">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="font-body text-sm font-medium text-cream/80 hover:text-ink hover:bg-lime px-4 py-2 rounded-full transition-all"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#booking"
            data-testid="nav-book-button"
            className="hidden md:inline-flex items-center gap-2 bg-lime text-ink font-display font-bold text-sm px-5 py-3 rounded-full hover:bg-hot hover:text-cream transition-colors"
          >
            Agendar ✦
          </a>
          <button
            data-testid="nav-menu-toggle"
            className="lg:hidden text-cream bg-white/5 border border-white/10 rounded-full p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="lg:hidden bg-ink border-t border-white/10 overflow-hidden"
          >
            <div className="flex flex-col p-5 gap-2">
              {LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`mobile-${l.testid}`}
                  onClick={() => setOpen(false)}
                  className="font-body text-base text-cream py-3 px-3 rounded-lg hover:bg-lime hover:text-ink transition-colors"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#booking"
                onClick={() => setOpen(false)}
                data-testid="mobile-nav-book-button"
                className="bg-lime text-ink font-display font-bold text-sm px-5 py-4 rounded-full text-center mt-3"
              >
                Agendar Sessão ✦
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
